import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/retryWhen';
import 'rxjs/add/operator/scan';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LoggingDao {

  _http: Http;

  constructor(
    http: Http
  ) {
    this._http = http;
  }

  get(useCache: boolean = true, ...config): Observable<any> {
    const [
      apiKey,
      interval,
      retry,
      timeout,
      url
    ] = config;

    const args = this.buildHeader(apiKey);
    return this._http.get(url, args)
      .map(res => res.json())
      .retryWhen(e => this.handleRetry(e, retry, interval, timeout));
  }

  post(data: any, ...config): Observable<any> {
    const [
      apiKey,
      interval,
      retry,
      timeout,
      url
    ] = config;

    const args = this.buildHeader(apiKey);
    return this._http.post(url, data, args)
      .map(res => res.json())
      .retryWhen(e => this.handleRetry(e, retry, interval, timeout));
  }

  private buildHeader(apiKey: string) {
    const headers = new Headers();
    headers.append('X-IHG-API-KEY', apiKey);

    const args: any = {
      headers: headers
    };
    return args;
  }

  private handleRetry = (
    errors: Observable<any>,
    retryCount: number = 10,
    delay: number = 5000,
    timeout: number = 10000
  ): Observable<any> => {

    return errors.scan((count, err) => {
      ++count;

      // no retrying for 400, 401, 404, or 407
      switch (err.status) {
        case 400:
        case 401:
        case 404:
        case 407:
          throw Error(err.status);
      }

      // retry a timeout and 500 - if we exceed the retry count (same count for all), throw an error
      if (count > retryCount) {
        switch (err.status) {
          case -1:
          case 500:
            throw Error(err.status);
          default:
        }
      }

      return count;
    }, 0)
      .takeWhile(count => count <= (retryCount + 1))
      .delay(delay)
      .timeout(timeout);
  };

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/logging.dao.ts